import {
    Code,
    HStack,
    Link,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Stack,
    Text
} from "@chakra-ui/react";
import React from "react";
import { FiMail } from "react-icons/fi";
import { MdError } from "react-icons/md";

export class ErrorBoundary extends React.Component {    
    constructor(props) {
      super(props);
      this.state = { error: undefined };
      
    }
  
    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
    }
  
    render() {
      if (this.state.error) {
        const error = `${this.state.error.message}
${this.state.errorInfo.componentStack}`
        
        return (
        <Modal 
            isOpen={this.state.error}
            onClose={()=>{}}
            colorScheme='red'
        >
            <ModalOverlay/>
            <ModalContent
                style={{
                    maxWidth: 'fit-content'
                }}
            >
                <ModalHeader paddingBottom={0}>
                    <HStack spacing={1}>
                        <MdError color='var(--chakra-colors-red-300)' size={30}/>
                        <Text fontSize="3xl">Error!</Text>
                    </HStack>
                </ModalHeader>
                <ModalBody>
                    <Stack spacing={3} paddingBottom={3}>
                        <Text>
                            Please, contact <Link 
                                href={`mailto:support@chronicle.software?subject=FIX+UI+Error&body=${encodeURIComponent(error)}`}
                                style={{
                                    color: 'var(--chakra-colors-blue-300)',
                                    textDecoration: 'underline'
                                }}
                                isExternal
                            >
                                support@chronicle.software
                                <FiMail
                                    style={{
                                        display: 'inline',
                                        verticalAlign: 'middle',
                                        margin: '0 2px'
                                    }}/>
                            </Link>
                            
                        </Text>
                        <Code whiteSpace='pre'>
                            {error}
                        </Code>
                    </Stack>
                </ModalBody>
            </ModalContent>
        </Modal>)
      }

      return this.props.children;
    }
  }